import { render, staticRenderFns } from "./platformInstructionDialog.vue?vue&type=template&id=26b7d7ae&"
import script from "./platformInstructionDialog.vue?vue&type=script&lang=js&"
export * from "./platformInstructionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b7d7ae')) {
      api.createRecord('26b7d7ae', component.options)
    } else {
      api.reload('26b7d7ae', component.options)
    }
    module.hot.accept("./platformInstructionDialog.vue?vue&type=template&id=26b7d7ae&", function () {
      api.rerender('26b7d7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/platformInstructionDialog.vue"
export default component.exports